import {RouteComponentProps} from 'react-router'

/**
 * Helper for extracting `RouteComponentProps` from a superset `props`.
 *
 * e.g. in  `render`:
 * ```
 * <ChildComponentThatNeedsRouteComponentPropsPassedIn
 *   {...routeProps(this.props)}
 *   otherProp={otherValue}
 * />
 * @param props
 */
export const routeProps = <Props extends RouteComponentProps<P>, P>(props: Props): RouteComponentProps<P> => ({
  match: props.match,
  location: props.location,
  history: props.history,
})



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/utils/react-router-helpers.ts